import React from 'react';
import {
  FormControl,
  FormLabel,
  GridItem,
  Switch,
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import Select from 'react-select';

const PreferencesForm = ({ formData, handleChange, entertainmentOptions = [] }) => {
  return (
    <>
      <GridItem>
        <FormControl>
          <FormLabel>Food Preference</FormLabel>
          <ChakraSelect
            value={formData.foodPreference || ''}
            onChange={(e) => handleChange('foodPreference', e.target.value)}
          >
            <option value="">Select Food Preference</option>
            <option value="veg">Vegetarian</option>
            <option value="non-veg">Non-Vegetarian</option>
            <option value="both">Both</option>
          </ChakraSelect>
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl>
          <FormLabel>Alcohol Preference</FormLabel>
          <ChakraSelect
            value={formData.alcoholPreference || ''}
            onChange={(e) => handleChange('alcoholPreference', e.target.value)}
          >
            <option value="">Select Alcohol Preference</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </ChakraSelect>
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl>
          <FormLabel>Entertainment Options</FormLabel>
          <Select
            isMulti
            value={formData.entertainmentOptions?.map(optId => {
              const option = entertainmentOptions.find(o => o._id === optId);
              return option ? { label: option.name, value: option._id } : null;
            }).filter(Boolean) || []}
            onChange={(selected) => {
              const options = selected ? selected.map(option => option.value) : [];
              handleChange('entertainmentOptions', options);
            }}
            options={entertainmentOptions.map(opt => ({
              label: opt.name,
              value: opt._id
            }))}
            placeholder="Select entertainment options"
          />
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl display="flex" alignItems="center">
          <FormLabel mb="0">Is Cold Lead?</FormLabel>
          <Switch
            isChecked={formData.isCold || false}
            onChange={(e) => handleChange('isCold', e.target.checked)}
          />
        </FormControl>
      </GridItem>
    </>
  );
};

export default PreferencesForm;
